import $ from "jquery";
import React from 'react';
import SessionManager from '../../routes/SessionManager';

class Support extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            zones: []
        }
    }

    onSupportLinkClick = (e) => {
        var sessionManager = new SessionManager()
        const user = sessionManager.readCookie('user');
        var ua = navigator.userAgent;
        var info = {
            browser: /Edge\/\d+/.test(ua) ? 'Microsoft Edge' : /MSIE 9/.test(ua) ? 'Explorer 9' : /MSIE 10/.test(ua) ? 'Explorer 10' : /MSIE 11/.test(ua) ? 'Explorer 11' : /MSIE\s\d/.test(ua) ? 'Explorer 8 and below' : /rv:11/.test(ua) ? ' Explorer 11' : /Firefox\W\d/.test(ua) ? 'Firefox' : /Chrom(e|ium)\W\d|CriOS\W\d/.test(ua) ? 'Google Chrome' : /\bSafari\W\d/.test(ua) ? 'Safari' : /\bOpera\W\d/.test(ua) ? 'Safari' : /\bOPR\W\d/i.test(ua) ? 'Opera' : typeof MSPointerEvent !== 'undefined' ? 'Explorer 8 and below' : '',
            os: /Windows NT 10/.test(ua) ? "win10" : /Windows NT 6\.0/.test(ua) ? "winvista" : /Windows NT 6\.1/.test(ua) ? "win7" : /Windows NT 6\.\d/.test(ua) ? "win8" : /Windows NT 5\.1/.test(ua) ? "winxp" : /Windows NT [1-5]\./.test(ua) ? "winnt" : /Mac/.test(ua) ? "mac" : /Linux/.test(ua) ? "linux" : /X11/.test(ua) ? "nix" : "",
            mobile: /iPhone|iP[oa]d/.test(ua) ? 'iOS (iPhone iPad)' : /Android/.test(ua) ? 'Android' : /BlackBerry|PlayBook|BB10/.test(ua) ? 'Blackberry' : /Mobile Safari/.test(ua) ? 'Undetected mobile device running Safari' : /webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(ua) ? 'Undetected mobile device' : 'Not a mobile',
            tablet: /Tablet|iPad/i.test(ua),
        };

        var sysInfo = [];
        sysInfo.push('*****System Info*****',
            ' UserAgent = ' + ua,
            ' Browser = ' + info.browser,
            ' OS = ' + info.os,
            ' Mobile = ' + info.mobile);
        if (info.tablet) {
            sysInfo.push(' Tablet = ' + info.table)
        };

        var appInfo = [];
        if (user.site_locations && user.site_locations.length > 0) {
            appInfo.push('*****Application Info*****',
                ' User ID: ' + user.user_login,
                ' Customer ID: ' + user.customer_id,
                ' Site ID: ' + user.site_selected.site_id,
                ' Site Name: ' + user.site_selected.site_name,
                ' Page Path: ' + window.location.pathname,
                ' Timezone: ' + user.site_selected.site_iana_timezone);
            if (user.zone_selected) {
                appInfo.push(
                    ' Zone Location Name: ' + user.zone_selected.location_name,
                    ' Zone Location ID: ' + user.zone_selected.location_id,
                    ' Zone Device ID: ' + user.zone_selected.device_id)
            };
        } else {
            appInfo.push('*****Application Info*****',
                ' User ID: ' + user.user_login,
                ' Customer ID: ' + user.customer_id,
                ' Site ID: No accessible sites',
                ' Page Path: ' + window.location.pathname);
        }

        var emailBody = '\n\n\n\n\nPlease retain the below Information for faster resolution!' +
            '\n_______________________________________________________________________________________\n' +
            appInfo.join('\n') + '\n' + sysInfo.join('\n');

        var url = "mailTo:support@sitekick.com?subject=Support Details&body=" + encodeURIComponent(emailBody);
        var anchorElement = document.createElement('a');
        document.body.append(anchorElement);
        anchorElement.href = url;
        anchorElement.click();
        $(anchorElement).remove();
    }

    render() {
        return (
            <span onClick={this.onSupportLinkClick} className="p-0">
                {this.props.children}
            </span>
        );
    }
}

export default Support;